/* OVANEA | correctifs d interface, 14 septembre 2026

   1. galerie produit : on change de media en glissant, a la souris comme au doigt
   2. bande de vignettes : glissement a la souris (le doigt defile deja tout seul)
   3. visionneuse plein ecran : meme geste
   4. code promo du tiroir panier : applique sans quitter la page

   Sur le point 4, le theme appelait handleDiscountForm, qui fait
   window.location.href = '/checkout?discount=' + code. Resultat : le client
   etait ejecte sur la page de paiement Shopify sans jamais voir le code
   applique dans son panier. On intercepte l evenement submit en phase de
   CAPTURE au niveau du document : c est le seul point d accroche qui passe
   avant un gestionnaire inline onsubmit, quel que soit l ordre de chargement
   des scripts du theme.

   Sur les points 1 a 3, on ne touche pas a la mecanique de la galerie : le
   geste se contente d actionner les deux boutons deja presents dans la page.
   La galerie reste seule maitresse du media affiche et du compteur. */

(function () {
  'use strict';

  var SEUIL = 45; /* deplacement minimal pour changer de media */
  var EVEIL = 6;  /* deplacement a partir duquel on tranche l axe du geste */

  /* =========================================================
     1 | glissement horizontal, generique
     ========================================================= */
  function brancherGlissement(zone, bPrec, bSuiv, ignorer) {
    if (!zone || !bPrec || !bSuiv || zone.dataset.ovGlisse === '1') return;
    zone.dataset.ovGlisse = '1';

    var pid = null, x0 = 0, y0 = 0, dx = 0, axe = null, avaler = false;

    zone.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (ignorer && e.target.closest && e.target.closest(ignorer)) return;
      pid = e.pointerId;
      x0 = e.clientX;
      y0 = e.clientY;
      dx = 0;
      axe = null;
      avaler = false;
    });

    zone.addEventListener('pointermove', function (e) {
      if (e.pointerId !== pid) return;
      var mx = e.clientX - x0;
      var my = e.clientY - y0;

      if (axe === null) {
        if (Math.abs(mx) < EVEIL && Math.abs(my) < EVEIL) return;
        /* Geste plutot vertical : on rend la main au defilement de la page. */
        axe = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
        if (axe === 'x') {
          zone.classList.add('is-dragging');
          try { zone.setPointerCapture(pid); } catch (err) {}
        }
      }
      if (axe !== 'x') return;

      e.preventDefault();
      dx = mx;
      /* 0.55 : le media suit le geste sans jamais sortir de son cadre. */
      zone.style.setProperty('--ov-dx', Math.round(dx * 0.55) + 'px');
    });

    function relacher(e) {
      if (e.pointerId !== pid) return;
      var horizontal = axe === 'x';
      var parcouru = dx;
      pid = null;
      axe = null;
      dx = 0;
      zone.classList.remove('is-dragging');
      zone.style.removeProperty('--ov-dx');
      if (!horizontal) return;
      /* Les fleches sont DANS la zone de glissement : leur clic programme
         remonte par le meme chemin que celui de l utilisateur. On desarme
         donc l avalage le temps de le declencher. */
      avaler = false;
      if (Math.abs(parcouru) >= SEUIL) {
        (parcouru < 0 ? bSuiv : bPrec).click();
      }
      avaler = Math.abs(parcouru) > EVEIL;
    }
    zone.addEventListener('pointerup', relacher);
    zone.addEventListener('pointercancel', relacher);

    /* Un glissement ne doit pas ouvrir la visionneuse ni fermer l overlay. */
    zone.addEventListener('click', function (e) {
      if (!avaler) return;
      if (ignorer && e.target.closest && e.target.closest(ignorer)) return;
      avaler = false;
      e.preventDefault();
      e.stopPropagation();
    }, true);

    zone.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  /* =========================================================
     2 | bande de vignettes, glissement a la souris
     ========================================================= */
  function brancherVignettes(bande) {
    if (!bande || bande.dataset.ovGlisse === '1') return;
    bande.dataset.ovGlisse = '1';

    var pid = null, x0 = 0, depart = 0, tire = false, avaler = false;

    bande.addEventListener('pointerdown', function (e) {
      /* Au doigt, le defilement natif fait deja le travail. */
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      pid = e.pointerId;
      x0 = e.clientX;
      depart = bande.scrollLeft;
      tire = false;
      avaler = false;
    });

    bande.addEventListener('pointermove', function (e) {
      if (e.pointerId !== pid) return;
      var d = e.clientX - x0;
      if (!tire) {
        if (Math.abs(d) < EVEIL) return;
        tire = true;
        bande.classList.add('is-dragging');
        try { bande.setPointerCapture(pid); } catch (err) {}
      }
      e.preventDefault();
      bande.scrollLeft = depart - d;
    });

    function relacher(e) {
      if (e.pointerId !== pid) return;
      pid = null;
      if (tire) avaler = true;
      tire = false;
      bande.classList.remove('is-dragging');
    }
    bande.addEventListener('pointerup', relacher);
    bande.addEventListener('pointercancel', relacher);

    bande.addEventListener('click', function (e) {
      if (!avaler) return;
      avaler = false;
      e.preventDefault();
      e.stopPropagation();
    }, true);

    bande.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  /* =========================================================
     3 | code promo applique sur place
     ========================================================= */
  function messageErreur(bloc, texte) {
    if (!bloc) return;
    bloc.textContent = texte;
    bloc.style.display = 'block';
  }

  function contientDesArticles(t) {
    return !!t.querySelector('.cart-item, [class*="cart-item"]');
  }

  function rafraichirTiroir() {
    return fetch('/?section_id=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = doc.querySelector('.drawer__inner');
        var tiroir = document.querySelector('cart-drawer');
        var dst = tiroir && tiroir.querySelector('.drawer__inner');
        if (!src || !dst) { window.location.reload(); return; }
        dst.innerHTML = src.innerHTML;
        /* On se fie au contenu, jamais a la classe posee au chargement. */
        var vide = !contientDesArticles(tiroir);
        tiroir.classList.toggle('is-empty', vide);
        dst.classList.toggle('is-empty', vide);
      });
  }

  function appliquerCode(f) {
    var champ = f.querySelector('input[name="cart-discount-field"]');
    var bouton = f.querySelector('button[type="submit"]');
    var bloc = f.querySelector('.cart-discount-form__error');
    var code = ((champ && champ.value) || '').trim();

    if (bloc) bloc.style.display = 'none';
    if (!code) { messageErreur(bloc, 'Entrez un code promo.'); return; }

    var libelle = bouton ? bouton.textContent : '';
    if (bouton) { bouton.disabled = true; bouton.textContent = 'Application...'; }

    /* Shopify pose le code sur la session puis redirige. On vise /cart.js pour
       recuperer le panier recalcule dans la foulee. La redirection a lieu que
       le code soit valide ou non : c est le panier qui fait foi, pas le
       statut HTTP. */
    fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (panier) {
        var vise = code.toUpperCase();
        var pose = (panier.cart_level_discount_applications || []).some(function (d) {
          return String(d.title || '').toUpperCase() === vise;
        });
        if (!pose) {
          pose = (panier.items || []).some(function (a) {
            return (a.discounts || []).some(function (d) {
              return String(d.title || '').toUpperCase() === vise;
            });
          });
        }
        if (!pose) {
          /* Deux codes de commande ne se cumulent pas : Shopify garde le
             premier pose et ignore le second sans rien dire. */
          var deja = (panier.cart_level_discount_applications || [])[0];
          if (deja && deja.title) {
            var e = new Error('conflit');
            e.dejaPose = deja.title;
            throw e;
          }
          throw new Error('code refuse');
        }
        if (f.closest('cart-drawer')) return rafraichirTiroir();
        window.location.reload();
      })
      .catch(function (err) {
        if (err && err.dejaPose) {
          messageErreur(bloc, 'Le code ' + err.dejaPose + ' est déjà appliqué. Un seul code par commande.');
        } else {
          messageErreur(bloc, 'Ce code ne semble pas valide.');
        }
      })
      .then(function () {
        if (bouton && bouton.isConnected) {
          bouton.disabled = false;
          bouton.textContent = libelle;
        }
      });
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.classList || !f.classList.contains('cart-discount-form')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    appliquerCode(f);
  }, true);

  /* =========================================================
     4 | bouton Copier a cote du code promo
     Ajoute en script et non en Liquid : le presse-papier demande de toute
     facon du JavaScript, donc un bouton rendu sans lui ne servirait a rien.
     ========================================================= */
  function copieDeSecours(txt, fini) {
    /* Safari ancien et contextes sans navigator.clipboard. */
    var z = document.createElement('textarea');
    z.value = txt;
    z.setAttribute('readonly', '');
    z.style.cssText = 'position:fixed;top:0;left:-9999px';
    document.body.appendChild(z);
    z.select();
    try { z.setSelectionRange(0, txt.length); } catch (e) {}
    try { document.execCommand('copy'); fini(); } catch (e) {}
    document.body.removeChild(z);
  }

  function brancherCopieCode() {
    Array.prototype.forEach.call(document.querySelectorAll('.ov-promo__txt code'), function (c) {
      if (c.dataset.ovCopie === '1') return;
      c.dataset.ovCopie = '1';
      var code = (c.textContent || '').trim();
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ov-promo__copy';
      b.textContent = 'Copier';
      b.setAttribute('aria-label', 'Copier le code promo ' + code);
      c.insertAdjacentElement('afterend', b);
      b.addEventListener('click', function () {
        var fini = function () {
          b.classList.add('is-ok');
          b.textContent = 'Copié';
          setTimeout(function () {
            b.classList.remove('is-ok');
            b.textContent = 'Copier';
          }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(fini, function () { copieDeSecours(code, fini); });
        } else {
          copieDeSecours(code, fini);
        }
      });
    });
  }

  /* =========================================================
     5 | branchement
     ========================================================= */
  function brancher() {
    brancherCopieCode();
    Array.prototype.forEach.call(document.querySelectorAll('.ov-gal'), function (gal) {
      brancherGlissement(
        gal.querySelector('.ov-gal__stage'),
        gal.querySelector('.ov-gal__nav--prev'),
        gal.querySelector('.ov-gal__nav--next'),
        'video, .ov-gal__nav'
      );
      brancherVignettes(gal.querySelector('.ov-gal__thumbs'));
    });
    Array.prototype.forEach.call(document.querySelectorAll('.ov-lb'), function (lb) {
      brancherGlissement(
        lb,
        lb.querySelector('.ov-lb__nav--prev'),
        lb.querySelector('.ov-lb__nav--next'),
        'video, .ov-lb__nav, .ov-lb__close'
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', brancher);
  } else {
    brancher();
  }
  window.addEventListener('load', brancher);
})();
